import React, { useEffect, useState } from "react";
import "./OrderdetailPage.css";
import default_product from "./../../../assets/default_product.png";
import { Dropdown, ListGroup, Row, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { FindPhone, ValidateTime } from "../../comman/components/TimeSence";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getRequestcall } from "../../comman/util/getRequest";
import { postRequestcall } from "../../comman/util/postRequest";
import {
  ORDER_DETAIL,
  ORDERDETAIL_VENDOR,
  ORDER_STATUS,
  SEND_ORDERSTATUS
} from "../../constants/apiurl";
import { FormLabel } from "../../comman/formgroup/FormgroupPage";
import moment from "moment";
import { toast } from "react-toastify";

const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);

function OrderlistPage(props) {
  const { access_token } = props;
  const { t } = useTranslation();
  const [orderDetail, setOrderDetail] = useState({});
  let getURL = window.location.pathname;
  var order_id = getURL.substring(getURL.lastIndexOf("/") + 1);
  let checkType = getURL.split("/");
  const [dateAccepted, setDateaccepted] = useState({
    state: "",
    updated_at: "",
  });
  const [datePacked, setDatePacked] = useState({ state: "", updated_at: "" });
  const [dateDispatch, setDateDispatch] = useState({
    state: "",
    updated_at: "",
  });
  const [dateDelivered, setDateDelivered] = useState({
    state: "",
    updated_at: "",
  });
  const [dateCancelled, setDateCancelled] = useState({
    state: "",
    updated_at: "",
  });
  const [packedLoader, setPackedLoader] = useState(true);
  const [load, setLoad] = useState(true);
  const [dispatchLoader, setDispatchLoader] = useState(true);
  const [deliveredLoader, setDeliveredLoader] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.deletepop.deleteorder"),
    sub_title: t("pages.deletepop.sub_title"),
    name: "",
    id: "",
    type: t("pages.deletepop.order"),
    order_status: "",
  });
  const orderStatus = [
    {
      orderstatus: "Accepted",
      orderstatus_tr: "Kabul edilmiş",
    },
    {
      orderstatus: "Packed",
      orderstatus_tr: "Paketlenmiş",
    },
    {
      orderstatus: "Dispatched",
      orderstatus_tr: "Sevk edilen",
    },
    {
      orderstatus: "Delivered",
      orderstatus_tr: "Teslim edilmiş",
    },
    {
      orderstatus: "Cancelled",
      orderstatus_tr: "İptal edildi",
    },
  ];

  useEffect(() => {
    callOrderDetailsList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.deletepop.deleteorder"),
      sub_title: t("pages.deletepop.sub_title"),
      name: "",
      id: "",
      type: t("pages.deletepop.order"),
      order_status: "",
    });
    props?.fetchHeaderContent(t("pages.orderdetail.title"), "", "");
    // eslint-disable-next-line
  }, [props?.language]);

  const callOrderDetailsList =async () =>{
    setLoad(true)
    await callOrderDetail()
    setLoad(false)
  }

  const callOrderDetail = async () => {
    let getResponsecall;
    if (checkType[1] === "vendor") {
      let geturl = ORDERDETAIL_VENDOR + `/${order_id}`;
      getResponsecall = await getRequestcall(geturl, access_token);
    } else {
      let apiurl = ORDER_DETAIL + `/${order_id}`;
      getResponsecall = await getRequestcall(apiurl, access_token);
    }
    if (getResponsecall?.status === 200) {
      let getData = await getResponsecall.json();
      setOrderDetail(getData?.data);
      getOrderDetail(getData?.data?.track_details);
    }
  };

  const getOrderDetail = (track_list) => {
    // eslint-disable-next-line array-callback-return
    track_list?.map((item) => {
      switch (item?.status) {
        case t("pages.Accepted"):
          setDateaccepted({
            status: item?.status,
            updated_at:
              item?.updated_at === null
                ? ""
                :moment(item?.updated_at).format("DD-MM-YYYY hh:mm A")
          });
          break;
        case t("pages.Packed"):
          setDatePacked({
            status: item?.status,
            updated_at:
              item?.updated_at === null
                ? ""
                : moment(item?.updated_at).format("DD-MM-YYYY hh:mm A"),
          });
          setTimeout(() => setPackedLoader(false), 1000);
          break;
        case t("pages.Dispatched"):
          setDateDispatch({
            status: item?.status,
            updated_at:
              item?.updated_at === null
                ? ""
                : moment(item?.updated_at).format("DD-MM-YYYY hh:mm A"),
          });
          setTimeout(() => setDispatchLoader(false), 1000);
          break;
        case t("pages.Delivered"):
          setDateDelivered({
            status: item?.status,
            updated_at:
              item?.updated_at === null
                ? ""
                :moment(item?.updated_at).format("DD-MM-YYYY hh:mm A"),
          });
          setTimeout(() => setDeliveredLoader(false), 1000);
          break;
        case t("pages.Cancelled"):
          setDateCancelled({
            status: item?.status,
            updated_at:
              item?.updated_at === null
                ? ""
                : moment(item?.updated_at).format("DD-MM-YYYY hh:mm A"),
          });
          break;
        default:
          break;
      }
    });
  };

  const orderstatusUpdate = async (status) => {
    let geturl =
      ORDER_STATUS +
      `?order_status=${status}&id=${order_id}&lang=${props?.language?.toLowerCase()}`;
    let getChangeorderapiResponce = await postRequestcall(
      geturl,
      access_token,
      ""
    );
    if (getChangeorderapiResponce?.status === 200) {
      await callOrderDetail();
      let getOrderurl = SEND_ORDERSTATUS + `?order_status=${status}&id=${order_id}&lang=${props?.language?.toLowerCase()}`
      await postRequestcall(getOrderurl,access_token,"");
      toast.success(t('pages.Order status changed'))
    }
  };

  const callCancelOrders = async () => {
    let geturl =
      ORDER_STATUS +
      `?order_status=${t("pages.Cancelled")}&id=${
        deleteInfo?.id
      }&lang=${props?.language?.toLowerCase()}`;
    let getChangeorderapiResponce = await postRequestcall(
      geturl,
      access_token,
      ""
    );
    if (getChangeorderapiResponce?.status === 200) {
      callOrderDetail();
      let getOrderurl = SEND_ORDERSTATUS + `?order_status=${t("pages.Cancelled")}&id=${deleteInfo?.id}&lang=${props?.language?.toLowerCase()}`
      await postRequestcall(getOrderurl,access_token,"");
      toast.success(t('pages.Order has been cancelled'))
    }
  };

  const cancelOrder = (item) => {
    setDeleteinfo({
      ...deleteInfo,
      name: item?.display_order_id,
      id: item?.id,
      order_status: item?.order_status,
    });
    setDeleteModal(true);
  };

  const invoiceDownload = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(
      `${
        process.env.REACT_APP_BASE_URL
      }/orderInvoice/${order_id}/${props.language.toLowerCase()}`,
      "_blank"
    );
  };
  if (load) {
    return (
      <div className="col-xl-9 orderdetail-centent mb-5 loader">
        <div className="d-flex align-center justify-content-between align-items-start">
          <h5 className="header-title">
            {t("pages.orderdetail.title")} 
          </h5>
        </div>
        <Row className={"orderdetail_row"}>
          <div className="col-8 mb-4">
            <Row className="list-header">
              <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
                <h5 className="row-header">{t("pages.orderdetail.products")}</h5>
              </div>
              <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
                <h5 className="row-header">{t("pages.orderdetail.price")}</h5>
              </div>
              <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
                <h5 className="row-header">{t("pages.orderdetail.qty")}</h5>
              </div>
              <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
                <h5 className="row-header">
                  {t("pages.orderdetail.totalprice")}
                </h5>
              </div>
            </Row>
           
            <div className="detail_spinner ">
              <div className="spinner_card px-4 py-2 mb-3">
                <Row className="list-header w-100 align-items-center">
                  <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
                   <div className="d-flex">
                    <div className="cover skeleton">
                        <LazyLoadImage id={"cover"} alt={""} />
                      </div>
                      <div className="content_skeleton pl-3 w-auto">
                        <div className="content ">
                          <small id="subtitle" className="skeleton"></small>
                        </div>
                      </div>
                   </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
                    <div className="content_skeleton">
                      <div className="content ">
                        <small id="subtitle" className="skeleton"></small>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
                    <div className="content_skeleton">
                      <div className="content ">
                        <small id="subtitle" className="skeleton"></small>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
                    <div className="content_skeleton">
                      <div className="content ">
                        <small id="subtitle" className="skeleton"></small>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
              <div className="card spinner_card p-0">
                <div className="card-body orderdetails">
                  <h5 className="header-title mb-3">
                    {checkType[1] === "user"
                      ? t("pages.orderdetail.storedetail")
                      : t("pages.orderdetail.customerdetail")}
                  </h5>
                  <div className="d-flex align-center justify-content-between align-items-start">
                    <FormLabel className={"cast_name"} require={false} label={checkType[1] === "user"
                    ? t("pages.orderdetail.storename")
                    : t("pages.orderdetail.name")} />
                    <span className="price-text">
                        <div className="content_skeleton">
                          <div className="content ">
                            <small id="subtitle" className="skeleton"></small>
                          </div>
                        </div>
                    </span>
                  </div>
                  <div className="d-flex align-center justify-content-between align-items-start">
                    <FormLabel className={"cast_name"} require={false} label={checkType[1] === "user"
                    ? t("pages.orderdetail.storenumber")
                    : t("pages.orderdetail.phone")} />
                    <span className="price-text">
                        <div className="content_skeleton">
                          <div className="content ">
                            <small id="subtitle" className="skeleton"></small>
                          </div>
                        </div>
                    </span>
                  </div>
                  {checkType[1] === "vendor" && (
                    <div className="d-flex align-center justify-content-between align-items-start">
                      <FormLabel className={"cast_name"} require={false} label={t("pages.orderdetail.email")}/>
                      <span className="price-text">
                          <div className="content_skeleton">
                            <div className="content ">
                              <small id="subtitle" className="skeleton"></small>
                            </div>
                          </div>
                      </span>
                    </div>
                  )}
                  <div className="d-flex align-center justify-content-between align-items-start">
                    <FormLabel className={"cast_name"} require={false} label={t("pages.orderdetail.type")}/>
                    <span className="price-text">
                        <div className="content_skeleton">
                          <div className="content ">
                            <small id="subtitle" className="skeleton"></small>
                          </div>
                        </div>
                    </span>
                  </div>
                  <div className="d-flex align-center justify-content-between align-items-start">
                    <FormLabel className={"cast_name"} require={false} label={t("pages.orderdetail.ordercreated")} />
                    <span className="price-text">
                        <div className="content_skeleton">
                          <div className="content ">
                            <small id="subtitle" className="skeleton"></small>
                          </div>
                        </div>
                    </span>
                  </div>
                  <div className="d-flex align-center justify-content-between align-items-start">
                  <FormLabel className={"cast_name"} require={false} label={checkType[1] === "vendor"
                    ? t("pages.orderdetail.delivery")
                    : t("pages.orderdetail.storeaddress")}/>
                    <span className="price-text">
                        <div className="content_skeleton">
                          <div className="content ">
                            <small id="subtitle" className="skeleton"></small>
                          </div>
                        </div>
                    </span>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          <div className="col-4 mb-4">
          <div className="card invoice_details h-100">
            <div className="card-body"></div>
            </div>
            </div>
        </Row>
        
      </div>
    );
  }

  return (
    <div className="col-xl-9 orderdetail-centent mb-5">
      <div className="d-flex align-center justify-content-between align-items-start">
        <h5 className="header-title">
          {t("pages.orderdetail.title")}{" "}
          <FormLabel className={"header-title pr-color"} require={false} label={orderDetail?.display_order_id} />
        </h5>
      </div>
      <Row className={"orderdetail_row"}>
        <div className="col-8 mb-4">
          <Row className="list-header">
            <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
              <h5 className="row-header">{t("pages.orderdetail.products")}</h5>
            </div>
            <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
              <h5 className="row-header">{t("pages.orderdetail.price")}</h5>
            </div>
            <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
              <h5 className="row-header">{t("pages.orderdetail.qty")}</h5>
            </div>
            <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
              <h5 className="row-header">
                {t("pages.orderdetail.totalprice")}
              </h5>
            </div>
          </Row>
          {orderDetail?.products?.map((item, index) => (
            <div className="detail-product mb-3"  key={index?.toString()}>
              <Row className="align-items-center">
                <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4 pro-detail">
                  <h5 className="mobile-header">
                    {t("pages.orderdetail.products")}
                  </h5>
                  <div className="image-div">
                    <LazyLoadImage
                      onError={(e) => {
                        e.target.src = default_product;
                      }}
                      src={item?.product_image_url}
                      className={"pro-image"}
                      alt={""}
                    ></LazyLoadImage>
                    <h5 className="header-title ms-2">
                      {props.language === "Tr"
                        ? item.title_in_tr
                        : item?.product_name}
                    </h5>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
                  <div className="item-box">
                    <h5 className="mobile-header">
                      {t("pages.orderdetail.price")}
                    </h5>
                    <h5 className="header-title">
                      {Number(item?.sub_total / item?.quantity).toFixed(2)}{" "}
                      {process.env.REACT_APP_CURRENCY_SYMBOL}
                    </h5>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-xl-2 col-lg-2">
                  <div className="item-box">
                    <h5 className="mobile-header">
                      {t("pages.orderdetail.qty")}
                    </h5>
                    <h5 className="header-title">
                      {" "}
                      X{" "}
                      {item?.quantity +
                        (props.language === "Tr"
                          ? `${`(` + item.product_qty + item?.unit_in_tr + `)`}`
                          : `${`(` + item.product_qty + item?.unit + `)`}`)}
                    </h5>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-xl-4 col-lg-4">
                  <div className="item-box border-bottom-0">
                    <h5 className="mobile-header">
                      {t("pages.orderdetail.totalprice")}
                    </h5>
                    <h5 className="header-title">
                      {Number(item?.sub_total).toFixed(2)}{" "}
                      {process.env.REACT_APP_CURRENCY_SYMBOL}
                    </h5>
                  </div>
                </div>
              </Row>
            </div>
          ))}
          <div className="card">
            <div className="card-body orderdetails">
              <h5 className="header-title mb-3">
                {checkType[1] === "user"
                  ? t("pages.orderdetail.storedetail")
                  : t("pages.orderdetail.customerdetail")}
              </h5>
              <div className="d-flex align-center justify-content-between align-items-start">
               <FormLabel className={"cast_name"} require={false} label={checkType[1] === "user"
                    ? t("pages.orderdetail.storename")
                    : t("pages.orderdetail.name")}/>
                <span className="price-text">
                  {checkType[1] === "user"
                    ? orderDetail?.store_name
                    : orderDetail?.user_first_name}
                </span>
              </div>
              <div className="d-flex align-center justify-content-between align-items-start">
              <FormLabel className={"cast_name"} require={false} label={checkType[1] === "user"
                    ? t("pages.orderdetail.storenumber")
                    : t("pages.orderdetail.phone")}/>
                <span className="price-text">
                  {checkType[1] === "user"
                    ?
                      <FindPhone country_code={orderDetail?.vendor_detail?.country_code} mobile={orderDetail?.vendor_detail?.mobile}/>
                    :
                      <FindPhone country_code={orderDetail?.country_code} mobile={orderDetail?.user_mobile}/>
                  }
                </span>
              </div>
              {checkType[1] === "vendor" && (
                <div className="d-flex align-center justify-content-between align-items-start">
                  <FormLabel className={"cast_name"} require={false} label={t("pages.orderdetail.email")}/>
                  <span className="price-text">{orderDetail?.email}</span>
                </div>
              )}
              <div className="d-flex align-center justify-content-between align-items-start">
                <FormLabel className={"cast_name"} require={false} label={t("pages.orderdetail.type")}/>
                <span className="price-text">
                  {orderDetail?.order_delivery_type === "store"
                    ? t("pages.Pickup at store free")
                    : t("pages.Home Delivery")}
                </span>
              </div>
              <div className="d-flex align-center justify-content-between align-items-start">
              <FormLabel className={"cast_name"} require={false} label={t("pages.orderdetail.ordercreated")} />
                <span className="price-text">
                  {moment(orderDetail?.created_at).format("DD-MM-YYYY")}
                 </span>
              </div>
              <div className="d-flex align-center justify-content-between align-items-start">
              <FormLabel className={"cast_name"} require={false} label={checkType[1] === "vendor"
                    ? t("pages.orderdetail.delivery")
                    : t("pages.orderdetail.storeaddress")}/>
                <span className="price-text">
                  {checkType[1] === "vendor"
                    ? orderDetail?.address
                    : orderDetail?.vendor_detail?.address}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-4 mb-4">
          <div className="card invoice_details">
            <div className="card-body">
              <div className="d-flex align-center justify-content-between align-items-start">
                <div className="order_isues">
                  <p className="date-time">
                    {t("pages.orderdetail.issuedate")}
                  </p>
                  <h5 className="date-time">
                    {moment(orderDetail?.created_at).format("DD-MM-YYYY")}
                  </h5>
                </div>
                <div className="order_due">
                  <p className="date-time">{t("pages.orderdetail.duedate")}</p>
                  <h5 className="date-time">
                    {dateDelivered.updated_at === ""
                      ? ""
                      : moment(orderDetail?.updated_at).format("DD-MM-YYYY")
                    }
                  </h5>
                </div>
              </div>
              <hr />
              <h5 className="header-secound">
                {t("pages.orderdetail.delivery_note")} -
              </h5>
              <p className="note-para">{t("pages.delivery_note")}</p>
              <hr />
              <div>
                <div className="d-flex align-center mb-3">
                  <h5 className="header-secound me-2">
                    {t("pages.orderdetail.change_status")}
                  </h5>
                  <Dropdown id="menu-drop" className="menu-drop">
                    <Dropdown.Toggle
                      className="d-flex justify-space"
                      variant="success"
                    >
                      <h5 className="text-14 mb-0 me-3">
                        {orderStatus.map((value, index) =>
                          <React.Fragment key={index?.toString()}>
                            {value.orderstatus === orderDetail?.order_status ? (
                              props.language === "Tr" ? (
                                value.orderstatus_tr
                              ) : (
                                orderDetail?.order_status
                              )
                            ) : (
                              <React.Fragment/>
                            )}
                          </React.Fragment>
                        )}
                      </h5>{" "}
                      <i className="icon_after arrow_down " />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="drop-menus order_update">
                      <ListGroup className="order_track border-0">
                        <h5 className="text-16 mb-0 pt-2 pb-3 p-2">
                          {t("pages.orderdetail.trackorder")}
                        </h5>
                        <ListGroup.Item
                          className={
                            dateCancelled.updated_at
                              ? "list_padding mt-2 status-tail-error"
                              : "list_padding mt-2 finished"
                          }
                        >
                          <div className="icon_tail"></div>
                          <div className="item_custome_icon accepted">
                            <span className="steps-item-icon">
                              <i className={`mask_icon check_icon white `} />
                            </span>
                          </div>
                          <div className="item_content accepted">
                            <div className="item_title d-flex justify-content-between align-items-center">
                              <h5 className="text-16 mb-0">
                                {t("pages.orderdetail.accepted")}
                              </h5>
                              <span className="icons-orderdetails">
                                <i className={`mask_icon check_icon white `} />
                              </span>
                            </div>
                            <div className="item-description">
                              <p className="mb-0">
                                <ValidateTime time={dateAccepted?.updated_at}/>
                              </p>
                            </div>
                          </div>
                        </ListGroup.Item>
                        {dateCancelled.updated_at === "" ? (
                          <>
                            <ListGroup.Item
                              className={
                                datePacked.updated_at
                                  ? "list_padding mt-2 finished"
                                  : "list_padding mt-2"
                              }
                            >
                              <div className="icon_tail"></div>
                              <div
                                className={
                                  datePacked.updated_at === ""
                                    ? "item_custome_icon"
                                    : "item_custome_icon packed"
                                }
                              >
                                <span className="steps-item-icon">
                                  <i className={`mask_icon pack_icon ${datePacked.updated_at === "" ?'grey':'white'}`} />
                                </span>
                              </div>
                              <div className="item_content packed">
                                <div className="item_title d-flex justify-content-between align-items-center">
                                  <h5 className="text-16 mb-0">
                                    {t("pages.orderdetail.packed")}
                                  </h5>
                                  {dateAccepted?.updated_at ===
                                  "" ? null : datePacked.updated_at === "" ? (
                                    packedLoader ? (
                                      <Spinner animation={"border"} />
                                    ) : (
                                      checkType[1] === "vendor" && (
                                        <button
                                          onClick={() =>
                                            orderstatusUpdate(
                                              t("pages.Packed"),
                                              setPackedLoader(true)
                                            )
                                          }
                                          className="plus_btn"
                                        >
                                          <i className={`mask_icon plus_icon grey `} />
                                        </button>
                                      )
                                    )
                                  ) : (
                                    <span className="icons-orderdetails">
                                      <i className={`mask_icon check_icon white `} />
                                    </span>
                                  )}
                                </div>
                                <div className="item-description">
                                  <p className="mb-0">
                                    <ValidateTime time={datePacked?.updated_at}/>
                                  </p>
                                </div>
                              </div>
                            </ListGroup.Item>
                            <ListGroup.Item
                              className={
                                dateDispatch.updated_at
                                  ? "list_padding mt-2 finished"
                                  : "list_padding mt-2"
                              }
                            >
                              <div className="icon_tail"></div>
                              <div
                                className={
                                  dateDispatch.updated_at === ""
                                    ? "item_custome_icon"
                                    : "item_custome_icon dispatch"
                                }
                              >
                                <span className="steps-item-icon">
                                  <i className={`mask_icon archive_icon ${datePacked.updated_at === "" ?'grey':'white'}`} />
                                </span>
                              </div>
                              <div className="item_content dispatch">
                                <div className="item_title d-flex justify-content-between align-items-center">
                                  <h5 className="text-16 mb-0">
                                    {t("pages.orderdetail.discpatch")}
                                  </h5>
                                  {datePacked?.updated_at ===
                                  "" ? null : dateDispatch.updated_at === "" ? (
                                    dispatchLoader ? (
                                      <Spinner animation={"border"} />
                                    ) : (
                                      checkType[1] === "vendor" && (
                                        <button
                                          onClick={() =>
                                            orderstatusUpdate(
                                              t("pages.Dispatched"),
                                              setDispatchLoader(true)
                                            )
                                          }
                                          className="plus_btn"
                                        >
                                          <i className={`mask_icon plus_icon grey `} />
                                        </button>
                                      )
                                    )
                                  ) : (
                                    <span className="icons-orderdetails">
                                       <i className={`mask_icon check_icon white `} />
                                    </span>
                                  )}
                                </div>
                                <div className="item-description">
                                  <p className="mb-0">
                                    <ValidateTime time={dateDispatch?.updated_at}/>
                                  </p>
                                </div>
                              </div>
                            </ListGroup.Item>
                            <ListGroup.Item
                              className={
                                dateDelivered.updated_at
                                  ? "list_padding mt-2 finished"
                                  : "list_padding mt-2"
                              }
                            >
                              <div
                                className={
                                  dateDelivered.updated_at === ""
                                    ? "item_custome_icon"
                                    : "item_custome_icon delivered"
                                }
                              >
                                <span className="steps-item-icon">
                                   <i className={`mask_icon bicycle ${dateDelivered.updated_at === "" ?'black':'white'} `} />
                                </span>
                              </div>
                              <div className="item_content delivered">
                                <div className="item_title d-flex justify-content-between align-items-center">
                                  <h5 className="text-16 mb-0">
                                    {t("pages.orderdetail.percel")}
                                  </h5>
                                  {dateDispatch?.updated_at ===
                                  "" ? null : dateDelivered.updated_at ===
                                    "" ? (
                                    deliveredLoader ? (
                                      <Spinner animation={"border"} />
                                    ) : (
                                      checkType[1] === "vendor" && (
                                        <button
                                          onClick={() =>
                                            orderstatusUpdate(
                                              t("pages.Delivered"),
                                              setDeliveredLoader(true)
                                            )
                                          }
                                          className="plus_btn"
                                        >
                                           <i className={`mask_icon plus_icon grey `} />
                                        </button>
                                      )
                                    )
                                  ) : (
                                    <span className="icons-orderdetails">
                                      <i className={`mask_icon check_icon white `} />
                                    </span>
                                  )}
                                </div>
                                <div className="item-description">
                                  <p className="mb-0">
                                    <ValidateTime time={dateDelivered?.updated_at}/>
                                  </p>
                                </div>
                              </div>
                            </ListGroup.Item>
                          </>
                        ) : (
                          <ListGroup.Item className="list_padding mt-2 status-tail-error error_title">
                            <div className="item_custome_icon">
                              <span className="steps-item-icon">
                                <i className={`mask_icon bicycle white `} />
                              </span>
                            </div>
                            <div className="item_content">
                              <div className="item_title d-flex justify-content-between align-items-center">
                                <h5 className="text-16 mb-0">
                                  {t("pages.orderdetail.cancelorder")}
                                </h5>
                                <span className="icons-orderdetails">
                                  <i className={`mask_icon check_icon white `} />
                                </span>
                              </div>
                              <div className="item-description">
                                <p className="mb-0">
                                  <ValidateTime time={dateCancelled?.updated_at}/>
                                </p>
                              </div>
                            </div>
                          </ListGroup.Item>
                        )}
                      </ListGroup>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="status_change">
                  {orderDetail?.order_status !== t("pages.Delivered") &&
                  orderDetail?.order_status !== t("pages.Cancelled") ? (
                    <button
                      onClick={() => cancelOrder(orderDetail)}
                      className="cancel-btn py-2 p-0"
                    >
                      {t("pages.orderdetail.cancel")}
                    </button>
                  ) : (
                    ""
                  )}
                  {checkType[1] === "user" && (
                    <h5
                      className="invoice_txt"
                      onClick={(e) => invoiceDownload(e)}
                    >
                      {t("pages.myorders.invoice_down")}
                    </h5>
                  )}
                </div>
              </div>
              <hr />
              <div className="d-flex align-center justify-content-between align-items-start">
               <FormLabel className={"cast_name"} require={false} label={t("pages.payment_card.subtotal")} />
                <span className="price-text">
                  {Number(orderDetail?.sub_total).toFixed(2)}{" "}
                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                </span>
              </div>
              <div className="d-flex align-center justify-content-between align-items-start">
              <FormLabel className={"cast_name"} require={false} label={t("pages.payment_card.vat")} />
                <span className="price-text">
                  {Number(orderDetail?.vat).toFixed(2)}{" "}
                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                </span>
              </div>
              <div className="d-flex align-center justify-content-between align-items-start">
              <FormLabel className={"cast_name"} require={false} label={t("pages.payment_card.discount")} />
                <span className="price-text">
                  {orderDetail?.offer_price
                    ? Number(orderDetail?.offer_price).toFixed(2)
                    : "0.00"}{" "}
                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                </span>
              </div>
              <div className="d-flex align-center justify-content-between align-items-start">
              <FormLabel className={"cast_name"} require={false} label={t("pages.payment_card.deliverycharges")} />
                <span className="price-text">
                  {Number(orderDetail?.charges).toFixed(2)}{" "}
                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                </span>
              </div>
              <hr />
              <div className="d-flex align-center justify-content-between align-items-start">
                <FormLabel className={"card-title"} require={false} label={t("pages.payment_card.totalamount")} />
                <span className="card-title text-green">
                  {Number(orderDetail?.order_total).toFixed(2)}{" "}
                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Row>
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={callCancelOrders}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  type: state?.login.type,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchHeaderContent })(OrderlistPage);
